if (document.querySelector("[data-leave-review-section]")) {
  const leaveReviewSection = document.querySelector("[data-leave-review-section]");
  const leaveReviewForm = leaveReviewSection.querySelector("[data-leave-review-form]");
  const leaveReviewStarsRadioButtons = leaveReviewSection.querySelectorAll("[data-star-radio-btn]");
  const howCanWeImproveDialog = document.querySelector("[data-how-can-we-improve-dialog]");
  const howCanWeImproveDialogForm = howCanWeImproveDialog.querySelector("#LeaveReviewContactForm");
  const howCanWeImproveDialogEmailField = howCanWeImproveDialog.querySelector("[data-how-can-we-improve-email-field]");
  const leaveReviewLottiePlayer = leaveReviewSection.querySelector("[data-leave-review-lottie]");
  // const leaveReviewLoader = document.querySelector("[data-leave-review-loader]");

  // constants & variables
  const REVIEWS__KLAVIYO_LIST_ID = "V65pC3"; // 5Star Reviewers list
  const leaveReviewLottieFileUrl = window.innerWidth > 1300 ? leaveReviewLottiePlayer.dataset.src : leaveReviewLottiePlayer.dataset.srcMobile;

  leaveReviewStarsRadioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", () => {
      const checkedRadioButton = leaveReviewSection.querySelector("[data-star-radio-btn]:checked");
      const checkedRadioButtonValue = parseInt(checkedRadioButton.value);

      if (checkedRadioButtonValue < 4) {
        const messageTextarea = howCanWeImproveDialogForm.querySelector("#how-can-we-improve-message-field");
        // resetHowWeCanImproveForm(howCanWeImproveDialogEmailField, messageTextarea, howCanWeImproveDialogForm);

        howCanWeImproveDialog.showModal();
        setTimeout(() => howCanWeImproveDialog.classList.add("fade-in"), 50);
        howCanWeImproveDialogEmailField.focus();
      }
    });
  });

  // document.getElementById("how_can_we_improve__submit_btn").addEventListener("click", function() {
  //   const messageTextarea = howCanWeImproveDialogForm.querySelector("#how-can-we-improve-message-field");

  //   if (validateHowWeCanImproveForm(howCanWeImproveDialogEmailField, messageTextarea, howCanWeImproveDialogForm)) {
  //     howCanWeImproveDialogForm.submit();
  //     localStorage.setItem('contact-complete-review', '1');
  //     window.location = '/pages/contact-complete-review';
  //   }
  // });

  leaveReviewForm.addEventListener("submit", e => {
    e.preventDefault();

    const chooseProductSelect = leaveReviewForm.querySelector("#leave-review-product-type-field");
    const emailInputElement = leaveReviewForm.querySelector("#leave-review-email-field");

    if (validateLeaveReviewForm(chooseProductSelect, emailInputElement, leaveReviewForm)) {
      const checkedRadioButton = leaveReviewSection.querySelector("[data-star-radio-btn]:checked");
      const checkedRadioButtonValue = parseInt(checkedRadioButton.value);

      if (checkedRadioButtonValue < 4) {
        howCanWeImproveDialog.showModal();
        setTimeout(() => howCanWeImproveDialog.classList.add("fade-in"), 50);
        howCanWeImproveDialogEmailField.focus();
        return;
      }


      // post a review to Judge.me
      $.ajax({ 
        type : 'POST',
        url : 'https://judge.me/api/v1/reviews',
        data : $('#leave-review__form').serialize(),
        success:function(result){
          addReviewersProfileToKlaviyoList(emailInputElement.value);
        }
      });
    }
  });

  async function addReviewersProfileToKlaviyoList(email) {
    const options = {
      method: 'POST',
      headers: {revision: '2024-05-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Newsletter Sign Up Form Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                },
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: REVIEWS__KLAVIYO_LIST_ID}}}
        }
      })
    };

    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=LmwnMm', options);

      if (response.status === 202) {
        localStorage.setItem('submission-review-success', '1');
        window.location = '/pages/submission-review-success';
      } else {
        // console.error('Error:', response);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  document.addEventListener("click", e => {
    if (!e.target.closest("[data-how-can-we-improve-dialog-close-btn]")) return;

    return;
    // howCanWeImproveDialog.classList.remove("fade-in");
    // setTimeout(() => howCanWeImproveDialog.close(), 350);
  });

  // lottie
  let sectionWasAlreadyInViewport = false;

  function reloadPlayer(player) {
    player.load(leaveReviewLottieFileUrl);
  
    player.addEventListener('ready', () => {
      player.setSpeed(0.4);
      player.play();
      // leaveReviewLoader.classList.add("leave-review-loader--fade-out");
    });
  }

  document.addEventListener("DOMContentLoaded", handleLottieAnimation);

  function handleLottieAnimation() {
    if (isSectionInViewPort(leaveReviewSection) && sectionWasAlreadyInViewport === false) {
      sectionWasAlreadyInViewport = true;
      reloadPlayer(leaveReviewLottiePlayer);

      setTimeout(() => {
        reloadPlayer(leaveReviewLottiePlayer);
      }, 4000);
    }
    if (!isSectionInViewPort(leaveReviewSection)) {
      sectionWasAlreadyInViewport = false;
    }
  }
}

function validateHowWeCanImproveForm(emailInputElement, messageTextarea, howCanWeImproveDialogForm) {
  const emailValue = emailInputElement.value;
  const messageValue = messageTextarea.value;
  const emailFormGroup = emailInputElement.closest("[data-form-group]");
  const messageFormGroup = messageTextarea.closest("[data-form-group]");
  const requiredFieldsErrorsMessages = howCanWeImproveDialogForm.querySelector("[data-required-fields-error-message]");

  requiredFieldsErrorsMessages.innerHTML = "";
  let isFormValid = true;

  if (!validateEmail(emailValue)) {
    emailFormGroup.classList.add("invalid");
    addErrorMessage(requiredFieldsErrorsMessages, "* Please enter a valid email address.");
    isFormValid = false;
  } else {
    emailFormGroup.classList.remove("invalid");
  }

  if (messageValue === "") {
    messageFormGroup.classList.add("invalid");
    addErrorMessage(requiredFieldsErrorsMessages, "* Please fill out required fields.");
    isFormValid = false;
  } else {
    messageFormGroup.classList.remove("invalid");
  }

  if (!isFormValid) {
    $(requiredFieldsErrorsMessages).slideDown(200);
  } else {
    $(requiredFieldsErrorsMessages).slideUp(200);
  }

  return isFormValid;
}

function resetHowWeCanImproveForm(emailInputElement, messageTextarea, howCanWeImproveDialogForm) {
  const emailFormGroup = emailInputElement.closest("[data-form-group]");
  const messageFormGroup = messageTextarea.closest("[data-form-group]");
  const requiredFieldsErrorsMessages = howCanWeImproveDialogForm.querySelector("[data-required-fields-error-message]");

  emailInputElement.value = "";
  messageTextarea.value = "";
  requiredFieldsErrorsMessages.innerHTML = "";
  $(requiredFieldsErrorsMessages).hide();
  emailFormGroup.classList.remove("invalid");
  messageFormGroup.classList.remove("invalid");
}

function validateEmail(email) {
  const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (emailRegex.test(email)) return true;
  return false;
}


function validateLeaveReviewForm(chooseProductSelect, emailInputElement, leaveReviewForm) {
  const selectedProductValue = chooseProductSelect.options[chooseProductSelect.selectedIndex].value;
  const emailValue = emailInputElement.value;
  const selectedProductFormGroup = chooseProductSelect.closest("[data-form-group]");
  const emailFormGroup = emailInputElement.closest("[data-form-group]");
  const requiredFieldsErrorsMessages = leaveReviewForm.querySelector("[data-required-fields-error-message]");

  requiredFieldsErrorsMessages.innerHTML = "";
  let isFormValid = true;

  if (selectedProductValue === "not-selected") {
    selectedProductFormGroup.classList.add("invalid");
    addErrorMessage(requiredFieldsErrorsMessages, "* Please select a product.");
    isFormValid = false;
  } else {
    selectedProductFormGroup.classList.remove("invalid");
  }

  if (!validateEmail(emailValue)) {
    emailFormGroup.classList.add("invalid");
    addErrorMessage(requiredFieldsErrorsMessages, "* Please enter a valid email address.");
    isFormValid = false;
  } else {
    emailFormGroup.classList.remove("invalid");
  }

  if (!isFormValid) {
    $(requiredFieldsErrorsMessages).slideDown(200);
  } else {
    $(requiredFieldsErrorsMessages).slideUp(200);
  }

  return isFormValid;
}

function addErrorMessage(container, message) {
  const errorMessage = document.createElement("p");
  errorMessage.textContent = message;
  container.appendChild(errorMessage);
}